import type { BannerTrackingMetadata } from "../types";

export function buildTrackingLink(
  baseLink: string,
  trackingMetadata?: BannerTrackingMetadata,
): string {
  try {
    const url = new URL(baseLink);

    if (trackingMetadata) {
      for (const [key, value] of Object.entries(trackingMetadata)) {
        if (value != null && value !== "") {
          url.searchParams.set(key, value);
        }
      }
    }

    const pageParams = new URLSearchParams(window.location.search);
    for (const [key, value] of pageParams.entries()) {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    }

    return url.toString();
  } catch {
    return baseLink;
  }
}
